import { client } from '@/client';

export function getRoleList(params) {
  return client.get('/api/sys_role_service/listRole', params);
}

// 创建角色
export function createRole(params) {
  return client.post('/api/sys_role_service/create', params);
}

// 更新角色
export function updateRole(params) {
  return client.post('/api/sys_role_service/update', params);
}

// 删除角色
export function deleteRole(params) {
  return client.post('/api/sys_role_service/delete', params);
}

// 权限树状信息
export function getPermissions(params) {
  return client.get('/api/sys_role_service/permission', params);
}

// 授权
export function grantPermissions(params) {
  return client.post('/api/sys_role_service/permissions', params);
}
